import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useOrchestrator } from "./contexts/OrchestratorContext";
import ResultScreen from "../ResultScreen";
import { clearGameConnection } from "../../utils/playerIdentity";

const ResultsPage: React.FC = () => {
  const { peerId } = useParams<{ peerId: string }>();
  const navigate = useNavigate();
  const { viewState } = useOrchestrator();
  const gameState = viewState.rawGameState;

  const handleQuit = () => {
    clearGameConnection();
    navigate("/multi-player");
  };

  const handleRestart = () => {
    // Navigate back to the same peerId route, which will show lobby if game is reset
    // The game state will need to be reset by the server/host
    if (peerId) {
      navigate(`/multi-player/${peerId}`);
    }
  };

  if (!gameState || gameState.status !== "finished") {
    // If game is not finished, redirect to the game page
    if (peerId) {
      navigate(`/multi-player/${peerId}`);
    }
    return null;
  }

  return (
    <div className="results-page-wrapper">
      <ResultScreen
        gameState={gameState}
        localStats={undefined}
        isSinglePlayer={false}
        onQuit={handleQuit}
        onRestart={gameState.isServer ? handleRestart : undefined}
      />
    </div>
  );
};

export default ResultsPage;

